<button type="submit" (click)="clicked($event)" [class.disabled]="disabled" class="btn btn-primary btn-md {{inputClasses}}" [disabled]="loading || disabled" [@wobble]="wobbleState" (@wobble.done)="resetAnimation()">
  <ng-container *ngIf="!loading">{{ btnCopy }}</ng-container>
  <div *ngIf="loading" class="spinner"></div>
</button>